import type { ComponentType } from "react";
import type { RowData } from "@tanstack/react-table";
import { type DataGridToggle, ToggleSlot } from "../cells/ToggleSlot";
import type { DataGridCellProps } from "../cells/types";

/** `col.toggle`: a `leading` slot component for a `DataGridToggle`. */
export const createToggleSlot =
    <TData extends RowData>() =>
    <TValue,>(
        toggle: DataGridToggle<TData, TValue>,
    ): ComponentType<DataGridCellProps<TData>> => {
        const DataGridToggleSlot = (
            props: Readonly<DataGridCellProps<TData>>,
        ) => <ToggleSlot {...props} toggle={toggle} />;
        return DataGridToggleSlot;
    };
